import { render, staticRenderFns } from "./ClientSapCard.vue?vue&type=template&id=18f7aca7&scoped=true"
import script from "./ClientSapCard.vue?vue&type=script&lang=js"
export * from "./ClientSapCard.vue?vue&type=script&lang=js"
import style0 from "./ClientSapCard.vue?vue&type=style&index=0&id=18f7aca7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f7aca7",
  null
  
)

export default component.exports